'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var Span = require('opentracing').Span;

var Scope = require('./scope');

var singleton = null;
var span = new Span();

var ScopeManager =
/*#__PURE__*/
function () {
  function ScopeManager() {
    _classCallCheck(this, ScopeManager);

    if (!singleton) {
      singleton = this;
    }

    return singleton;
  }

  _createClass(ScopeManager, [{
    key: "active",
    value: function active() {
      return new Scope(span);
    }
  }, {
    key: "activate",
    value: function activate(span, finishSpanOnClose) {
      return new Scope(span, finishSpanOnClose);
    }
  }]);

  return ScopeManager;
}();

module.exports = ScopeManager;